import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import {
  Observable,
  map,
  firstValueFrom,
  Subject,
  takeUntil,
  finalize,
} from "rxjs";
import { IResponse } from "../models/response";
import { HttpClient } from "@angular/common/http";
import * as JSZip from "jszip";
import * as FileSaver from "file-saver";
import { DialogService } from "libs/core/src/lib/services/dialog.service";
import { LoadingService } from "libs/core/src/lib/services/loading.service";

@Injectable({
  providedIn: "root",
})
export class AttachmentService {
  constructor(
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loadingService: LoadingService
  ) {}

  downloadAttachment(attachmentId: string, isprojectschedule?: boolean): Observable<any> {
    return this._http
      .get(apiconstants.API_ATTACHMENT + `/${attachmentId}?isprojectschedule=${isprojectschedule}`)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  downloadFileFromUrl(url: string, filename: string, pdf?, hideExtension?) {
    // filename with extension is required, Example 'Item1.jpg' , 'Item2.pdf'
    var $unsubscribe = new Subject<void>();
    if (url !== undefined && url !== null && url.trim() !== "") {
      this.getBlobFromURL(url)
        .pipe(takeUntil($unsubscribe))
        .subscribe((response) => {
          if (response) {
            let blob: any = new Blob([response], {
              type: "text/json; charset=utf-8",
            });
            const url = window.URL.createObjectURL(blob);
            const anchorElement: HTMLAnchorElement =
              document.createElement("a");
            anchorElement.href = url;
            if (!hideExtension) {
              let extension;
              if (typeof pdf === "string") {
                extension = pdf === "pdf" ? ".pdf" : ".xlsx";
              } else {
                extension = pdf ? ".pdf" : ".jpg";
              }
              anchorElement.download = filename + extension;
            } else {
              anchorElement.download = filename;
            }

            const clickEvent = new MouseEvent("click", {
              view: window,
              bubbles: true,
              cancelable: false,
            });
            anchorElement.dispatchEvent(clickEvent);
          }
        });
    } else {
      this._dialogService.showToast(
        "File is being uploaded in background. Please check again in a while.",
        "Warning"
      );
    }
  }

  getBlobFromURL(url): Observable<any> {
    return this._http.get(url, { responseType: "blob" as "json" });
  }

  getBlobFromURLWithParams(url, params, isBlob = false): Observable<any> {
    if (!isBlob) {
      return this._http.post(url, params, {
        responseType: "arraybuffer" as "json",
      });
    }
    return this._http.post(url, params, { responseType: "blob" as "json" });
  }

  getReportResponse(url, param) {
    return this._http.post(url, param);
  }

  returnBlob(url, filename: string, pdf?) {
    var $unsubscribe = new Subject<void>();
    return new Promise((resolve, reject) => {
      return this._http
        .get(url, { responseType: "blob" as "json" })
        .pipe(takeUntil($unsubscribe))
        .subscribe((response: any) => {
          if (response) {
            let blob: any = new Blob([response], {
              type: "text/json; charset=utf-8",
            });
            return resolve(blob);
          }
        });
    });
  }

  async createZip(files: any[], zipName: string) {
    const zip = new JSZip();
    const name = zipName + ".zip";
    for (let counter = 0; counter < files.length; counter++) {
      const element = files[counter];
      const fileData: any = await this.getFile(element);
      if (fileData) {
        const blob: any = new Blob([fileData], {
          type: "" + fileData.type + "",
        });
        zip.file(element.substring(element.lastIndexOf("/") + 1), blob);
      }
    }
    zip.generateAsync({ type: "blob" }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, name);
      }
    });
  }

  async getFile(url: string) {
    return firstValueFrom(
      await this._http.get<any>(url, { responseType: "blob" as "json" })
    );
  }
}
